import gql from 'graphql-tag';

export const GET_API_KEYS = gql`
  query(
    $searchWord: String
  ) {
    GetApiKeys(
      searchWord: $searchWord
    ) {
      ApiKyeLists{
        id
        name
        ip
        api_key
      }
    }
  }
`;

export const REGIST_API_KEY = gql`
    mutation (
        $id:   ID
        $name: String!
        $ip:   String!
      ) {
        RegistApiKey(
          id: $id
          name: $name
          ip: $ip
        ) {
          result
      }
    }
`;

export const DELETE_API_KEY = gql`
mutation (
      $id: ID!
    ) {
      DeleteApiKey(
        id: $id
      ){
        result
      }
    }
`;
